import { dateFormat, getClientBreadCrumbs, userFullName } from "helpers/common";
import { useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import { useGetNoteQuery } from "store/services/note";
import dots from 'Assets/images/three-dots.png'
import { generatePath, useNavigate, useParams } from "react-router-dom";
import AddNotesModal from "components/Modals/AddNotesModal";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { CREATE_NOTES, EDIT_NOTES, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Breadcrumbs, CstmPagination, NoRecordFoundV2 } from "components/Common/Common";
import { useDeleteNoteMutation, useGetNotesListQuery } from "store/services/V2/notes";
import confirmDialogV2 from "utils/confirmationDialogV2";
import userImg from 'Assets/images/user.png'
import AddNotesCollaboratorsModal from "components/Modals/AddNotesCollaborators";
import { useGetSchoolClientDataQuery } from "store/services/clients/school.client";
import { useDeleteAttendanceMutation, useUpdateAttendanceMutation } from "store/services/clients/attendance";
import downArrow from "Assets/images/downArro.png"
import rightArrow from "Assets/images/rightArro.png"
import { useGetHomeEducationDetailsQuery } from "store/services/clients/homeEducation";
import { useGetPrivateClientDetailsQuery } from "store/services/clients/private";
import { useChatterClientDetailsQuery, useGetChatterClientAttendanceQuery } from "store/services/clients/chatter";

const ChatterAttendanceTracker = ({ }) => {
    const navigate = useNavigate()
    const { id: clientId } = useParams()
    const clientType = "chatter"

    const { data: attendanceDetails, isFetching: attendanceDetailsFetching, isLoading: attendanceDetailsLoading } = useGetChatterClientAttendanceQuery({ clientId })
    const { data: clientDetails, isLoading, isFetching, refetch } = clientType == "school" ? useGetSchoolClientDataQuery(clientId) : clientType == "private" ? useGetPrivateClientDetailsQuery(clientId) : clientType == "chatter" ? useChatterClientDetailsQuery(clientId) : useGetHomeEducationDetailsQuery(clientId);
    const clientCaseloadTherapist = clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist

    // const breadcrumbItems = [
    //     { label: "School Client", path: SCHOOL_CLIENT_LIST },
    //     { label: userFullName(clientDetails) || "Client Details", path: generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }) },
    //     { label: "Attendance Details" },
    // ];
    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "Attendance Details"), [clientType, clientDetails, clientId]);

    const [openDiscipline, setOpenDiscipline] = useState(null);

    const toggleDiscipline = (id) => {
        setOpenDiscipline(prev => prev === id ? null : id);
    };

    return (
        <>

            {
                (isLoading || attendanceDetailsLoading) ? <LoadingIndicator /> : <div className="">
                    {(isFetching || attendanceDetailsFetching) && <LoadingOverlay />}
                    <section
                        className={`position-relative ClientDetail`}
                    >
                        <Container fluid>
                            <Row className="pt-3" style={{ paddingLeft: "12px" }}>
                                <Col lg="6">
                                    <Breadcrumbs items={breadcrumbItems} />
                                </Col>
                            </Row>
                            <div style={{ padding: "12px", borderRadius: "4px" }}>

                                <Row className="justify-content-between" >
                                    <Col lg='9'>
                                        <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                            Attendance Details
                                        </p>
                                    </Col>
                                    <Col lg='2' style={{ textAlign: "center" }}>

                                    </Col>
                                </Row>
                                {
                                    attendanceDetails?.length > 0 ? <div className="mt-2">

                                        <table className="w-100">
                                            <thead>
                                                <tr>
                                                    <th className="fw-medium w-50" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        NAME
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        TOTAL ATTENDED
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                        TOTAL SCHEDULED
                                                    </th>
                                                    <th className="fw-medium text-center" style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }} ></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {attendanceDetails?.map((item, index) => {
                                                    return (
                                                        <>
                                                            <tr key={index} onClick={() => toggleDiscipline(item?.program?.id)} style={{ backgroundColor: "#F8F8F8" }}>
                                                                {/* <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F", }}>
                                                                    <span className={`discipline-${item?.caseDiscipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.caseDiscipline?.assign_term}</span>
                                                                </td> */}
                                                                <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>{item?.program?.name}</td>
                                                                <td className="text-center" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                    {item?.program?.lessonDates?.filter((x) => x?.attendance?.attendance == 'present')?.length}
                                                                </td>
                                                                <td className="text-center" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                    {item?.program?.lessonDates?.length}
                                                                </td>
                                                                <td className="text-center" style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: 0 }}>
                                                                    <img
                                                                        src={openDiscipline === item.id ? downArrow : rightArrow}
                                                                        width={openDiscipline === item.id ? 12 : 7}
                                                                        alt="toggle"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            {openDiscipline === item?.program?.id &&
                                                                item?.program?.lessonDates?.map((session, i) => {
                                                                    return (
                                                                        <tr key={i} style={{ backgroundColor: "white" }}>
                                                                            <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>
                                                                                <div className="d-flex align-items-center gap-10">
                                                                                    {/* <img
                                                                                        src={therapist?.caseTherapist?.therapist_detail?.profile_picture || userImg}
                                                                                        width={26}
                                                                                        height={26}
                                                                                        style={{ borderRadius: "50%" }}
                                                                                    /> */}
                                                                                    <span className="text-capitalize">{session?.attendance?.attendance || "Absent"}</span>
                                                                                </div>
                                                                            </td>
                                                                            <td colSpan={1} style={{ padding: "15px 10px", textAlign: "center", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }}>
                                                                                <span className="">{dateFormat(session?.session_date, "MMM DD, YYYY")}</span>
                                                                            </td>
                                                                            <td style={{ padding: "15px 10px", borderBottom: "1px solid #8F8F8F", borderRadius: "0" }} colSpan={2}></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </>
                                                    )
                                                })
                                                }
                                            </tbody>
                                        </table>

                                        {/* <CstmPagination
                                            totalPages={totalPages}
                                            activePage={currentPage}
                                            className="paginationV2"
                                            handlePageChange={handlePageChange}
                                        /> */}
                                    </div> : <NoRecordFoundV2 message="No Record Found." />
                                }
                            </div>
                        </Container>
                    </section>
                </div>
            }
        </>
    );

};

export default ChatterAttendanceTracker;